import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { PerfectScrollbarConfigInterface } from 'ngx-perfect-scrollbar';
import { Pedido } from 'src/app/models/pedido';
import { UsuarioLogado } from 'src/app/models/usuario-logado';
import { CarregandoService } from 'src/app/services/carregando.service';
import { GlobalService } from 'src/app/services/global.service';
import { NotificacaoService } from 'src/app/services/notificacao.service';
import { PedidoService } from 'src/app/services/pedido.service';
import swal from 'sweetalert2';

@Component({
  selector: 'app-cupom-desconto-modal',
  templateUrl: './cupom-desconto-modal.component.html',
  styleUrls: ['./cupom-desconto-modal.component.scss']
})
export class CupomDescontoModalComponent implements OnInit {

  idCupom: any;
  pedido: Pedido;
  limiteDescontoUsuario = 0;
  descontoMaximo = 0;

  usuarioLogado: UsuarioLogado;

  public config: PerfectScrollbarConfigInterface = {};

  constructor(public dialogRef: MatDialogRef<CupomDescontoModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any, private carregandoService: CarregandoService,
    private notificacaoService: NotificacaoService, private pedidoService: PedidoService, private globalService: GlobalService) {
    this.idCupom = data.idCupom;
  }

  async ngOnInit() {

    this.usuarioLogado = await this.globalService.consultaUsuario();

    this.buscarPedido();
  }

  buscarPedido() {
    this.carregandoService.mostra('buscaPedido');

    this.pedidoService.consultarCompleto(this.idCupom).subscribe(async orc => {
      this.pedido = orc.venda;
      this.limiteDescontoUsuario = orc.limDesc;
      this.descontoMaximo = this.pedido.cupomDesconto !== null ? this.pedido.cupomDesconto : this.limiteDescontoUsuario;

      this.carregandoService.esconde('buscaPedido');
    }, (erro) => {
      this.carregandoService.esconde('buscaPedido');
      this.notificacaoService.erro(erro);
    });
  }

  validaCupomDesconto() {

    if (this.usuarioLogado.limDesc < this.pedido.cupomDesconto) {

      swal({
        title: 'ATENÇÃO!!',
        html: 'Desconto acima do permitido: <b>' + this.usuarioLogado.limDesc.toLocaleString() + '% </b><br/>Vendedor: ' + this.usuarioLogado.nome,
        type: 'warning',
        confirmButtonClass: 'btn btn-warning',
        buttonsStyling: false,
        allowEnterKey: false
      }).then((result) => {

      });

      this.pedido.cupomDesconto = this.usuarioLogado.limDesc;
    }

    this.descontoMaximo = this.pedido.cupomDesconto;
  }

  adicionarCupomDesconto() {
    this.pedido.cupomDesconto = 0;
    this.descontoMaximo = 0;
    this.pedido.percentual = 0;
  }

  excluirCupomDesconto() {
    this.pedido.cupomDesconto = null;
    this.descontoMaximo = this.limiteDescontoUsuario;
  }

  salvar() {

    if (this.pedido.percentual > this.pedido.cupomDesconto) {
      this.pedido.percentual = this.pedido.cupomDesconto;
    }

    this.carregandoService.mostra('salvarCupomDesconto');
    this.pedidoService.salvarCupomDesconto(this.idCupom, this.pedido.cupomDesconto, true).subscribe((resp: any) => {

      this.dialogRef.close(true);
      this.carregandoService.esconde('salvarCupomDesconto');

    }, (erro) => {
      this.carregandoService.esconde('salvarCupomDesconto');
      this.notificacaoService.erro(erro);
    });
  }

  fechar() {
    this.dialogRef.close();
  }

}
